import { useUserStore } from '@/store';

import { type BoundaryProps, ErrorBoundary } from './ErrorBoundary';

export const ErrorBoundaryAuth = (props: BoundaryProps) => (
  <ErrorBoundary
    {...props}
    errorMessage="Authentication Error"
    redirectTo="/login"
    onRetry={() => {
      useUserStore.getState().logout();
    }}
  />
);
